import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=3ac96c34&scoped=true&"
import script from "./OrderRow.vue?vue&type=script&lang=js&"
export * from "./OrderRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac96c34",
  null
  
)

export default component.exports